(function () {
  var root = document.querySelector("[data-partner-root]");
  if (!root) return;

  var form = root.querySelector("[data-partner-form]");
  var statusEl = root.querySelector("[data-partner-status]");

  if (!form) return;

  // Capture ?aff= / ?ref= for Tier-2 recruit attribution
  try {
    var params = new URLSearchParams(window.location.search);
    var ref =
      params.get("aff") ||
      params.get("ref") ||
      params.get("referredBy") ||
      "";
    if (ref) {
      try {
        sessionStorage.setItem("sora_partner_ref", ref);
      } catch (e) {}
    } else {
      try {
        ref = sessionStorage.getItem("sora_partner_ref") || "";
      } catch (e2) {
        ref = "";
      }
    }
    var refInput = form.querySelector("[data-partner-referred-by]");
    if (refInput && ref) refInput.value = ref;
  } catch (e3) {}

  function apiBase() {
    return (root.getAttribute("data-api-base") || "").replace(/\/$/, "") ||
      "https://sora-climate-bridge.onrender.com";
  }

  function formatError(err) {
    if (err == null || err === "") return "";
    if (typeof err === "string") return err;
    if (typeof err === "object") {
      if (typeof err.message === "string" && err.message && err.message !== "[object Object]") {
        return err.message;
      }
      if (typeof err.error === "string") return err.error;
      if (err.error && typeof err.error === "object" && typeof err.error.message === "string") {
        return err.error.message;
      }
      try {
        return JSON.stringify(err);
      } catch (e) {
        return "Request failed";
      }
    }
    return String(err);
  }

  function setStatus(msg, isError) {
    if (!statusEl) return;
    statusEl.textContent = msg || "";
    statusEl.classList.toggle("is-error", Boolean(isError));
  }

  function collectPayload() {
    var fd = new FormData(form);
    var roles = [];
    form.querySelectorAll('input[name="roles"]:checked').forEach(function (el) {
      roles.push(el.value);
    });
    var frameAck = form.querySelector("[data-frame-ack]");
    var preferred = String(fd.get("preferredCode") || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "")
      .slice(0, 16);
    return {
      fullName: String(fd.get("fullName") || "").trim(),
      email: String(fd.get("email") || "").trim(),
      socialHandles: String(fd.get("socialHandles") || "").trim(),
      preferredCode: preferred || undefined,
      payoutMethod: String(fd.get("payoutMethod") || "").trim(),
      roles: roles,
      framePolicyAck: Boolean(frameAck && frameAck.checked),
      referredBy: String(fd.get("referredBy") || "").trim(),
      customerId: String(fd.get("customerId") || "").trim() || undefined,
      source: fd.get("source") || "sora-partner-with-us",
      channel: fd.get("channel") || "partner-with-us-page",
    };
  }

  function validate(payload) {
    if (!payload.fullName || payload.fullName.length < 2) {
      return "Enter your full name.";
    }
    if (!payload.email || payload.email.indexOf("@") < 0) {
      return "Enter a valid email address.";
    }
    if (!payload.socialHandles) {
      return "Add at least one social handle or website.";
    }
    if (!payload.payoutMethod) {
      return "Select Bank Transfer or Stripe.";
    }
    if (!payload.roles.length) {
      return "Select at least one role.";
    }
    if (!payload.framePolicyAck) {
      return "Acknowledge THE FRAME (no product gifting or free-sample unboxing) before submitting.";
    }
    if (!payload.preferredCode || payload.preferredCode.length < 3) {
      return "Enter a preferred checkout code (3–16 letters/numbers, e.g. sammy10).";
    }
    return null;
  }

  async function postJson(url, body) {
    var res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    var data = await res.json().catch(function () {
      return {};
    });
    return { ok: res.ok, status: res.status, data: data };
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    var payload = collectPayload();
    var err = validate(payload);
    if (err) {
      setStatus(err, true);
      return;
    }

    setStatus("Creating your SORA account + application…", false);
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    try {
      var base = apiBase();
      var primary = await postJson(base + "/api/partner/apply", payload);

      if (primary.ok) {
        var id = primary.data.id || "";
        var track = primary.data.trackingUrl || "";
        var code = primary.data.discountCode || "";
        var dash = primary.data.dashboardUrl || "/pages/partner-dashboard";
        var token = primary.data.partnerToken || "";
        if (token) {
          try {
            localStorage.setItem("sora_partner_token", token);
          } catch (e4) {}
        }
        var msg =
          "Application received" +
          (id ? " · reference " + id : "") +
          ". Check your email for account activate + welcome (THE FRAME restated).";
        if (code) {
          msg += " Your shareable code: " + code + ".";
        }
        if (track) {
          msg += " Tracking link: " + track + ".";
        }
        msg += " Opening Partner Dashboard…";
        setStatus(msg, false);
        form.reset();
        window.setTimeout(function () {
          window.location.href = token
            ? "/pages/partner-dashboard?token=" + encodeURIComponent(token)
            : dash.indexOf("http") === 0
              ? dash
              : "/pages/partner-dashboard";
        }, 900);
        return;
      }

      var apiErr = formatError(primary.data && primary.data.error);
      if (!apiErr && primary.data && primary.data.code === "frame_policy_required") {
        apiErr = "Acknowledge THE FRAME before applying.";
      }
      if (!apiErr && primary.data && primary.data.code === "preferred_code_required") {
        apiErr = "Enter a preferred checkout code (e.g. sammy10).";
      }
      if (!apiErr && primary.data && primary.data.code === "preferred_code_invalid") {
        apiErr = "Preferred code must be 3–16 letters/numbers and not a reserved word.";
      }
      if (!apiErr && primary.data && primary.data.code === "preferred_code_reserved") {
        apiErr = "Code taken/reserved — try another preferred code.";
      }
      if (!apiErr && primary.data && primary.data.code === "preferred_code_taken") {
        apiErr = "Code taken/reserved — try another preferred code.";
      }
      throw new Error(apiErr || "Could not submit application");
    } catch (ex) {
      var shown = formatError(ex && ex.message) || formatError(ex);
      if (!shown || shown === "[object Object]") {
        shown =
          "Could not submit. Email hello@soraclimate.com with Ambassador in the subject.";
      }
      setStatus(shown, true);
    } finally {
      if (btn) btn.disabled = false;
    }
  });
})();
